var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_deposit",
    transform: "translate(-21 -262)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(21 262)",
    fill: "#1d3960"
  }), /*#__PURE__*/React.createElement("g", {
    id: "small-plus_24px",
    transform: "translate(25 266)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundry",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_332",
    "data-name": "Line 332",
    y2: 8,
    transform: "translate(4 0)",
    fill: "none",
    stroke: "#3bb0ff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_333",
    "data-name": "Line 333",
    x2: 8,
    transform: "translate(0 4)",
    fill: "none",
    stroke: "#3bb0ff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.723de700dfbc3198bfe4e4683c028181.svg";
export { ForwardRef as ReactComponent };